import { Confirmation, SuccessToast } from "../../Utils/SweetAlert";
import { useNavigate } from "react-router-dom";
import { UserLogout } from "../../Api/auth";
import { removeSecureItem } from "../../Utils/secureStorage";

const Logout = () => {
    const navigate = useNavigate();

    Confirmation('Are you sure you want to Logout?').then(async (confirm) => {
        if (confirm.isConfirmed) {
            await UserLogout().then((res) => {
                SuccessToast(res?.data?.message || "Logout successfully.");
                removeSecureItem("accessToken");
                removeSecureItem("userData");
                removeSecureItem("permissions");
                window.location.assign("/");
            }).catch((error) => {
                ErrorToast(error?.message || "Something went wrong.");
            })
        } else if (confirm?.isConfirmed == false && confirm?.isDismissed == true) {
            window.location.assign("/");
        }
        else {
            navigate("/")
        }
    });
}

export default Logout;